import { Promise } from 'bluebird'
import $ from 'jquery'
import queryString from 'querystring-browser'
import _ from 'underscore'
import auth from './auth'

const METHOD_GET = 'GET'
const METHOD_POST = 'POST'
const METHOD_PUT = 'PUT'
const METHOD_PATCH = 'PATCH'
const METHOD_DELETE = 'DELETE'

export default {

  queryStringWithAuth (paramsObj) {
    var authParams = {}
    authParams[auth.PARAM_ACCESS_TOKEN] = auth.getToken()

    return '?' + queryString.stringify(_.extend(paramsObj || {}, authParams))
  },

  ajax (type, url, data, notAuthorizedHandler) {
    return new Promise((resolve, reject) => {
      var request = {
        type: type,
        url: url
      }
      if (data) {
        request.data = JSON.stringify(data)
        request.contentType = 'application/json; charset=utf-8'
        request.dataType = 'json'
      }
      // console.log('AJAX REQUST', request)
      $.ajax(request).done(resolve).fail(reject)
    })
    .catch({ status: 401 }, (error) => {
      if (notAuthorizedHandler) {
        console.log('Not authenticated - redirecting to login')
        notAuthorizedHandler()
      }
      throw error
    })
  },

  get (url, notAuthorizedHandler) {
    return this.ajax(METHOD_GET, url, null, notAuthorizedHandler)
  },

  put (url, data, notAuthorizedHandler) {
    return this.ajax(METHOD_PUT, url, data, notAuthorizedHandler)
  },

  patch (url, data, notAuthorizedHandler) {
    return this.ajax(METHOD_PATCH, url, data, notAuthorizedHandler)
  },

  post (url, data, notAuthorizedHandler) {
    return this.ajax(METHOD_POST, url, data, notAuthorizedHandler)
  },

  delete (url, notAuthorizedHandler) {
    return this.ajax(METHOD_DELETE, url, notAuthorizedHandler)
  }
}



// WEBPACK FOOTER //
// ./src/httpRequest.js